export default __webpack_public_path__ + "static/media/jspm.2eb0e212.svg";